/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$tabs-tab-height: 68px !default;
$tabs-tab-height-mobile: 48px !default;
$tabs-tab-border-width: 4px !default;
$tabs-tab-padding: 24px !default;
$tabs-tab-margin-header-content: 18px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  box-sizing: border-box;
  overflow: visible;
}

.#{$prefix}tab-headers {
  position: relative;
  margin-bottom: $tabs-tab-margin-header-content;
  height: $tabs-tab-height;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: $tabs-tab-border-width;
    background-color: v(tabBorderColor);
  }

  @include for-size(phone) {
    height: $tabs-tab-height-mobile;
  }

  .#{$prefix}absolute-wrapper {
    display: flex;
    // position: absolute;
    position: relative;
    height: $tabs-tab-height;
    z-index: 10;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    } //hide scrollbar for chrome
    overflow: -moz-scrollbars-none; //hide scrollbar for mozilla
    -ms-overflow-style: none; //hide scrollbar for internet explorer
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
    //align-items: center;

    @include for-size(phone) {
      height: $tabs-tab-height-mobile;
    }

    .#{$prefix}tab-header {
      @include eon-typography(copy);
      border: 0;
      padding-top: $tabs-tab-padding - 2;
      padding-right: $tabs-tab-padding;
      padding-left: $tabs-tab-padding;

      margin: 0px;
      outline: none;
      cursor: pointer;
      color: v(textColor);
      white-space: nowrap;

      @include for-size(phone) {
        padding-top: $tabs-tab-padding * 0.5;
        padding-bottom: $tabs-tab-padding * 0.5;
        padding-left: customDivide($tabs-tab-padding, 3);
        padding-right: customDivide($tabs-tab-padding, 3);
      }

      &:hover {
        background: v(tabHoverColor);
        border-bottom: $tabs-tab-border-width solid v(tabBorderColor);
      }

      &.#{$prefix}forceHoverState {
        background: v(tabFocusColor);
        border-bottom: $tabs-tab-border-width solid v(tabBorderColor);
      }

      &.#{$prefix}active {
        font-weight: $font-weight-medium;
      }
    }

    .#{$prefix}highlight-border {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 0;
      height: $tabs-tab-border-width;
      background-color: v(tabActiveBorderColor);
      transition: all 250ms $transition-timing-function 0s;
    }
  }
}
